import { Box } from "@mui/material";
import { useVisorDocumentosStore } from "hooks/useVisorDocumentosStore";
import { useEffect } from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";

export const DocumentPDF = ({ blob }: { blob: string }) => {
  const { scale, numPages, changeNumPages, changeScale } =
    useVisorDocumentosStore();

  useEffect(() => {
    if (window.innerWidth < 600) {
      changeScale(0.5);
    } else {
      changeScale(2.5);
    }
    // eslint-disable-next-line
  }, [window.innerWidth]);

  const onDocumentLoadSuccess = ({ numPages }: any) => {
    changeNumPages(numPages);
  };
  useEffect(() => {
    changeNumPages(0);
    // eslint-disable-next-line
  }, [blob]);

  return (
    <Box sx={{ overflowX: "auto" }} className="overflow-hidden ml-4">
      {blob ? (
        <>
          {numPages > 200 ? (
            <iframe
              src={blob}
              title="documento"
              style={{
                width: "85vw",
                height: "600px",
                border: "none",
                overflow: "hidden",
                display: "block",
                margin: 0,
                padding: 0,
              }}
              className="overflow-hidden"
            ></iframe>
          ) : (
            <Document
              file={blob}
              onLoadSuccess={onDocumentLoadSuccess}
              renderMode="canvas"
              loading={<p className="text-center">Cargando...</p>}
              noData="No se pudo localizar el documento"
              onLoadError={(error) => {
                console.error(error);
              }}
              onLoadProgress={(data) => {
                console.log(data);
              }}
              onSourceError={(error) => {
                console.error(error);
              }}
              options={{
                workerSrc: "/pdf.worker.js",
                cMapUrl: "cmaps/",
                cMapPacked: true,
              }}
            >
              {Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  height={600}
                  scale={scale}
                  className="py-3"
                  onRenderError={(error) => {
                    console.error(error);
                  }}
                />
              ))}
            </Document>
          )}
        </>
      ) : null}
    </Box>
  );
};
